/* future.icon.svg.js */

module.exports = {
    icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.7 18.38" xml:space="preserve">
        <path class="foreground-gl" d="M19.47,6.85a9.85,9.85,0,0,0-3.66-5.08A1,1,0,0,0,14.64,3.4,7.84,7.84,0,1,1,4.2,4.56,1,1,0,0,0,2.7,3.22,9.85,9.85,0,0,0,16,17.58,9.85,9.85,0,0,0,19.47,6.85Z" transform="translate(-0.21 -1.23)"/>
        <polygon class="foreground-gl" points="4.52 6.32 7.51 0 0.54 0.57 4.52 6.32"/>
        <path class="foreground-gl" d="M13.81,14.53a.67.67,0,0,1-.39-.12L8.62,11V4.37a.68.68,0,0,1,1.35,0v6l4.22,3a.68.68,0,0,1-.39,1.23Z" transform="translate(-0.21 -1.23)"/>
        </svg>
    `
};
